import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { Util } from '../../common/util/util';

//Токен для отмены
let cancelTokenSource: any = null;
export const fetchSearch = createAsyncThunk(
  'search/fetch-search',
  async (_: { value: string }, thunkApi) => {
    try {
      /*    if (cancelTokenSource != null) {
      cancelTokenSource.cancel();
    }
    //Создаем новый токен (чтобы можно было отменить запрос при вводе новой буквы для поиска)
    cancelTokenSource = axios.CancelToken.source();*/
      const dataResponse = await axios({
        method: 'get',
        url: '/api/live-search-ext',
        headers: {
          token: Util.getTokenSecurity(),
        },
        params: {
          q: _.value,
          limit: 7,
          offset: 0,
        },
        /*      cancelToken: cancelTokenSource.token,*/
      });
      return thunkApi.fulfillWithValue(dataResponse.data.catalog);
    } catch (error) {
      if (error instanceof Error) {
        return thunkApi.rejectWithValue(error.message);
      } else {
        return thunkApi.rejectWithValue('Loading Error');
      }
    }
  }
);

export const fetchSearchPage = createAsyncThunk(
  'search/fetch-search-page',
  async (
    _: { value: string; limit: number; sort: string; availability: boolean },
    thunkApi
  ) => {
    try {
      const dataResponse = await axios({
        method: 'get',
        baseURL: process.env.REACT_APP_BASE_URL_API,
        url: '/api/search',
        headers: {
          token: Util.getTokenSecurity(),
        },
        params: {
          q: _.value,
          limit: _.limit,
          offset: 0,
          /*sort: _.sort,
          availability: _.availability ? 'availability' : 'no',*/
        },
      });
      return thunkApi.fulfillWithValue(dataResponse.data.catalog);
    } catch (error) {
      if (error instanceof Error) {
        return thunkApi.rejectWithValue(error.message);
      } else {
        return thunkApi.rejectWithValue('Loading Error');
      }
    }
  }
);
